export default "__VITE_ASSET__D7Txy5vq__"